module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "chap1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("Preface")])]), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_vm._v("W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HY ARE WRITERS")]), _vm._v(" so drawn to championship prizefights that they will cross continents and fly across oceans to be present at these spectacles?")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("I was pondering this again some years ago as Norman Mailer and I met at the bar of the Montreal headquarters of Sugar Ray Leonard, counting down the hours to the crucial welterweight title fight with the stone-fisted Panamanian, Roberto Duran. Norman and I traded observations, speculations, breathless predictions as we have been doing ever since a long night in Miami when we dissected until dawn Cassius Clay’s curious dethroning of the curiously misnamed Sonny Liston.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("Sonny had been the centerpiece of a highly charged gathering in Chicago where he had destroyed the brave rabbit Floyd Patterson in a single round, in a fight scene that could have doubled as a summer writers’ conference. In addition to Mailer, who was at his most provocative that week, one could sit in on literary seminars attended by Jimmy Baldwin, Ben Hecht, William Saroyan, and George Plimpton, where Pulitzer Prize judges and ring officials could be denounced with equal intensity.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("This marriage of literateurs and hard-core fanciers of the Sweet Science started long before Jack London, Ring Lardner, and Ernest Hemingway. It goes back at least three thousand ")]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("years, all the way to Homer, who covered the Greek Games where boxing was respected to the point of worship as a liberal art. In 1184 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("B.C.")]), _vm._v(", in the last year of the siege of Troy, Homer was writing a blow-by-blow of the epic battle between Epeus and Euryalus, the Muhammad Ali and Joe Frazier of their day.")])]), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "poem3",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Amid the circle now each champion stands,")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("And poises high in air his iron hands:")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("With clashing gauntlets now they fiercely close.")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("Their crackling jaws reecho to the blows …")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Three thousand years later poets were still setting down their quills to see and often report a stirring boxing match. In the bareknuckle days of English glory, when prizefights were officially forbidden but stoutly supported by The Fancy, Lord Byron would eagerly push away from an epic poem, hop into a barouche-and-four, and urge his coachman on until they reached the tavern some sixty miles from London where the next great fight for the belt was about to take place. Byron was there, cheering his favorite on, when Gentleman John Jackson relieved Daniel Mendoza of his unprecedented crown by swinging “The Jew Champion” around by his long, thick hair. With Jackson as his boxing instructor and close companion, Byron was at ringside for John Gully’s savage sixty-four-round battle with Pierce the Game Chicken. Indeed, Byron hung out at the Horse and Dolphin, the Toots Shor’s of its day, where the suave, educated black American fighter Bill Richmond held sway. He was there when the match was made between the British idol Tom Cribb and Richmond’s protégé, the formidable ex-slave from Virginia, Tom Molineaux. When the rematch in Leicester drew an unruly crowd of 25,000, Lord Byron was one of the first to reach the grounds. He pasted clippings of the fight on his famous screen.")])]), _c('p', {
    staticClass: "ind"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v("For a vivid description of a big fight, British nineteenth-century style, there is William Hazlitt’s essay on Thomas (the Gasman) Hickman’s contest with Bill Neate, “like Ajax, with ")]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v("Atlantean shoulders fit to bear the pugilistic reputation of all Bristol.” The Gasman, in turn, in Hazlitt’s celebrated prose, was compared to Diomed, “light, vigorous, elastic, his back glistening in the sun as he moved about like a panther’s hide.”")])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "ind"
  }, [_vm._v("From Homer to Hazlitt, Arthur Conan Doyle, and George Bernard Shaw, from London and Lardner to Hemingway, from A. J. Liebling and Nelson Algren to Norman Mailer, Pete Hamill, and Joyce Carol Oates, from Athens to Zaire (where even Dr. Hunter Thompson found his way), we seem irresistibly drawn to these ceremonial combats.")]), _vm._v(" "), _c('p', {
    staticClass: "ind"
  }, [_vm._v("We find ourselves at one with John Milton, that most unexpected of fight fans, who wrote in "), _c('i', [_vm._v("Samson Agonistes:")])]), _vm._v(" "), _c('p', {
    staticClass: "poem3",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("I sorrowed at his captive state,")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("but minded")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("Not to be absent at that")]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_vm._v("spectacle.")]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("Let’s get it on! the old master seems to be saying if we translate him into twentieth-century vernacular. I’ll be looking for him, along with the ghosts of Homer and Lord Byron, at the next writers’ conference at Caesar’s Palace, or MGM Grand, or wherever the next epic encounter captures the imagination of the writers who see The Fight as a microcosm, an intensification of the life forces we struggle to understand.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f949784","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5-chap1.vue
// module id = 72
// module chunks = 0